import { createAction } from 'redux-actions';
export const saveCustomer = createAction('REFUND/CUSTOMER/SAVE_CUSTOMER');
